<template>
    <div>
        <el-table v-loading="loading" border :data="tableData" style="width: 541px" max-height="200">
            <el-table-column show-overflow-tooltip prop="licensePlateNo" label="车牌" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="standardTypeName" label="车型" width="180">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="introduceCompanyName" label="引入分公司" width="180">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import {
    supplierAffiliatedVehicleGetFormData
} from '../../../api/attachmentCar.js'
export default {
    props: ['fdId'],
    data() {
        return {
            tableData: [],
            loading: false,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.loading = true
            supplierAffiliatedVehicleGetFormData({fdId: this.fdId}).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.data.supplierAffiliatedVehicleList || []
                }
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="less" scoped></style>
